<script lang="ts">
  export let label: string;
</script>

<div class="my-4 flex items-center justify-center">
  <span class="rounded-full border border-border bg-card px-3 py-1 text-[11px] font-medium uppercase tracking-wide text-muted-foreground shadow-sm">{label}</span>
</div>
